//* 조문객용 부고문자 컴포넌트
import { FC } from 'react';

import { BugoData } from '@shared/api/bugo/bugo.interface';
import { fileBucketUrl } from '@shared/utils/fileUtils';
import bottomBanner from 'src/assets/banner/bottomBanner.jpg';
import topLogo from 'src/assets/logo/topLogo.png';

import { ObituaryLayout } from './ObituaryLayout';

interface Props {
  bugo: BugoData;
  forMember?: boolean;
}

const Obituary: FC<Props> = function Obituary({ bugo, forMember }: Props) {
  const hardCustomConfig = bugo.fevent.hardCustomConfig;
  const useCustomConfig = hardCustomConfig?.useCustomConfig === true;
  const bugoBrand = bugo.bugoBrand;

  if (useCustomConfig) {
    return (
      <ObituaryLayout
        bugo={bugo}
        forMember={forMember}
        logoImage={
          hardCustomConfig?.headerImage
            ? fileBucketUrl(hardCustomConfig.headerImage.url, 'raw')
            : topLogo
        }
        footerImage={
          hardCustomConfig?.footerImage
            ? fileBucketUrl(hardCustomConfig.footerImage.url, 'raw')
            : bottomBanner
        }
        footerLink={bugoBrand?.bugoAgency?.homepageUrl}
        showFlower={hardCustomConfig?.hideFlowerOrderLink !== true}
        emptyAccountMessage={hardCustomConfig?.emptyAccountMessage}
      />
    );
  }

  return (
    <ObituaryLayout
      bugo={bugo}
      forMember={forMember}
      logoImage={topLogo}
      footerImage={bottomBanner}
      footerLink={bugoBrand?.bugoAgency?.homepageUrl}
      showFlower={true}
    />
  );
};

export default Obituary;
